module.exports = __webpack_public_path__ + "img/flamethrower-turret-base-north.1ded24c5.png";